import {
   REQUEST_AUTHENTICATE,
   RECEIVE_USER,
   AUTHENTICATION_FAILURE,
   RECEIVE_TOKEN,
   RECEIVE_CHECK_AUTH_FAILED,
   REQUEST_CHECK_AUTH,
   LOGOUT,
   REQUEST_REGISTER,
   RECEIVE_REGISTERED_USER,
   REGISTRATION_FAILED,
   RECEIVE_ROLES,
   RECEIVE_USERS,
   RECEIVE_ENTITIES,
   SAVE_ROLE,
   SAVE_MY_STATE,
   USER_DETAIL
} from './types';
import axios from "axios";
import { CONFIG } from '../../config'
const API_HOST = CONFIG.modules['accounts'].host

axios.interceptors.request.use(
   config => {
       const token = localStorage.getItem('authToken')
       if (token) {
           config.headers['Authorization'] = token
       }
       return config
   },
   error => {
       Promise.reject(error)
   })

//Normal Login with Password 
export const requestAuthenticate = () => {
   return {
      type: REQUEST_AUTHENTICATE
   };
}

export const authenticationFailure = (error) => {
   return {
      type: AUTHENTICATION_FAILURE,
      payload: error
   }
}


export const receiveToken = (token) => {
   return {
      type: RECEIVE_TOKEN,
      payload: token
   }
}

export const receiveRoles = (data) => {
   return {
      type: RECEIVE_ROLES,
      payload: data
   }
}

export const saveRole = (data) => {
   return {
      type: SAVE_ROLE,
      payload: data
   }
}


export const authenticate = (data) => async (dispatch) => {
   dispatch(requestAuthenticate());
   localStorage.removeItem('authToken');
   axios.post(API_HOST + '/auth/login', data)
      .then(async (response) => {
         if (response.data && response.data.success) {
            localStorage.setItem('authToken', `${response.data.token}`);
            dispatch(receiveToken(`Bearer ${response.data.token}`))
            dispatch(receiveUser({...response.data.user,ozone: response.data.ozone}))
            dispatch(receiveRoles(response.data.roles))
            dispatch(saveRole(response.data.role))
         }
         else dispatch(authenticationFailure(response.data))
      })
      .catch((error) => {
         if (error.response) {
            dispatch(authenticationFailure(error.response.data))
          }
      })
}

export const receiveUsers = (data) => {
   return {
      type: RECEIVE_USERS,
      payload: data
   }
}


export const getUsers = (data) => async (dispatch) => {
   const token = localStorage.getItem('authToken');
   if(!token)return
   axios.get(API_HOST, {
      headers: {
         Authorization: token
      }
   })
      .then(async (response) => {
         if (response.data && response.data.success) {
            dispatch(receiveUsers(response.data.users))
         }
      })
      .catch((error) => {
         if (error.response) {
          }
      })
}

export const receiveEntities = (data) => {
   return {
      type: RECEIVE_ENTITIES,
      payload: data
   }
}


export const getEntities = (type) => async (dispatch) => {
   const token = localStorage.getItem('authToken');
   if(!token)return
   axios.get(API_HOST+`/entity?entityName=${type}`, {
      headers: {
         Authorization: token
      }
   })
      .then(async (response) => {
         if (response.data && response.data.success) {
            dispatch(receiveEntities({data:response.data.data, type}))
         }
      })
      .catch((error) => {
         if (error.response) {
          }
      })
}


// Check Auth
export const requestCheckAuth = () => {
   return {
      type: REQUEST_CHECK_AUTH
   }
}

export const verifyAuthToken = () => async (dispatch) => {
   dispatch(requestCheckAuth())
   const token = localStorage.getItem('authToken');
   if (token) {
      axios.get(API_HOST + '/auth/verifyToken', {
         headers: {
            Authorization: token
         }
      })
         .then(function (response) {
            if (response.data && response.data.success) {
               dispatch(receiveUser({...response.data.user, ozone: response.data.ozone}))
               dispatch(receiveRoles(response.data.roles))
               dispatch(saveRole(response.data.role))
            }
            else {
               dispatch(receiveCheckAuthFailed(response.data))
            }
         })
         .catch((error) => {
            if (error.response) {
               dispatch(receiveCheckAuthFailed(error.response.data))
            }
            
         })
   }
   else {
      dispatch(receiveCheckAuthFailed({ error: 'token does not exist' }))
   }

}

export const receiveUser = (user) => {
   return {
      type: RECEIVE_USER,
      payload: user
   }
}

export const receiveCheckAuthFailed = () => {
   return {
      type: RECEIVE_CHECK_AUTH_FAILED
   }
}

//LOGOUT 
export const requestLogout = () => async (dispatch) => {
   localStorage.removeItem('authToken');
   dispatch(logout())
}
export const logout = () => {
   return {
      type: LOGOUT
   }
}


//Register Account
export const requestRegister = () => {
   return {
      type: REQUEST_REGISTER
   }
}

export const receiveRegister = (user) => {
   return {
      type: RECEIVE_REGISTERED_USER,
      payload: user
   }
}

export const registerFailed = (data) => {
   return {
      type: REGISTRATION_FAILED,
      payload: data
   }
}

const registerAccount = (data, role, dispatch) => {
   dispatch(requestRegister())
   const token = localStorage.getItem('authToken');
   axios.post(API_HOST, {...data, role}, {
      headers: {
         Authorization: token
      }
   })
      .then(async (response) => {
         if (response.data && response.data.success) {
            dispatch(receiveRegister(response.data.user))
         }
         else dispatch(registerFailed(response.data))
      })
      .catch((error) => {
         if(error.response) {
            dispatch(registerFailed(error.response.data))
         }
      })
}

export const registerUser = (data, role) => dispatch => {
   registerAccount(data, role, dispatch)
}

export const getRoles = () => dispatch => {
 
   axios.get(API_HOST+'/roles')
      .then(async (response) => {
         if (response.data && response.data.success) {
            dispatch(receiveRoles(response.data.roles))
         }
         // else dispatch(registerFailed(response.data))
      })
      .catch((error) => {
         if(error.response) {
            // dispatch(registerFailed(error.response.data))
         }
      })
}

export const receiveMyState = (data) => {
   return {
      type: SAVE_MY_STATE,
      payload: data
   }
}

export const getMyState = () => dispatch => {
 
   axios.get(API_HOST+'/my-state')
      .then(async (response) => {
         if (response.data && response.data.success) {
            dispatch(receiveMyState(response.data.data))
         }
         // else dispatch(registerFailed(response.data))
      })
      .catch((error) => {
         if(error.response) {
            // dispatch(registerFailed(error.response.data))
         }
      })
}

export const setUserDetail = (data) => {
   return {
      type: USER_DETAIL,
      payload: data
   }
}
